module.exports = __webpack_public_path__ + "img/hero-banners-dropdown-search-mazda-24.4e61569c.jpg";